import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { Store, Users, MapPin, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
export function About() {
  useDocumentMeta('About Kjergaard Sports | Lake Benton, Minnesota Sporting Goods Store', 'Learn about Kjergaard Sports, a rural, high-volume destination store in Lake Benton, Minnesota with approximately 5,000 guns on hand and practical, knowledgeable service.');
  return <div data-id="element-129">
      <PageHero title="About Kjergaard Sports" image="https://cdn.magicpatterns.com/uploads/6KbpNKGWUu4crVHhGcrQiK/home-hero-store-interior.jpg" alt="Inside Kjergaard Sports sporting goods store in Lake Benton, Minnesota" data-id="element-130" />

      <section className="py-20 bg-brand-offwhite" data-id="element-131">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-132">
          <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-133">
            <div data-id="element-134">
              <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-135">
                A Rural Destination Store
              </h2>
              <p className="text-lg text-brand-charcoal/80 mb-6 leading-relaxed" data-id="element-136">
                Kjergaard Sports is not your typical sporting goods store.
                Located in rural Lake Benton, Minnesota, we have grown into a
                massive destination for hunters, sport shooters, collectors, and
                outdoor enthusiasts.
              </p>
              <p className="text-lg text-brand-charcoal/80 mb-8 leading-relaxed" data-id="element-137">
                With approximately 5,000 guns on hand, our inventory rivals the
                largest big-box retailers, but we maintain the humble,
                unpretentious atmosphere of a local outfitter. We believe in
                providing a space where customers can browse an enormous
                selection in person, handle the equipment, and make informed
                decisions.
              </p>

              <div className="grid sm:grid-cols-2 gap-6" data-id="element-138">
                <div className="bg-brand-bone p-6 rounded-sm border border-brand-cream" data-id="element-139">
                  <ShieldCheck className="w-8 h-8 text-brand-hunter mb-4" data-id="element-140" />
                  <h3 className="font-serif text-xl mb-2" data-id="element-141">Massive Inventory</h3>
                  <p className="text-brand-charcoal/70" data-id="element-142">
                    Approximately 5,000 firearms in stock, plus optics, ammo,
                    and gear.
                  </p>
                </div>
                <div className="bg-brand-bone p-6 rounded-sm border border-brand-cream" data-id="element-143">
                  <MapPin className="w-8 h-8 text-brand-hunter mb-4" data-id="element-144" />
                  <h3 className="font-serif text-xl mb-2" data-id="element-145">Worth the Drive</h3>
                  <p className="text-brand-charcoal/70" data-id="element-146">
                    Customers regularly travel hundreds of miles to visit our
                    Lake Benton location.
                  </p>
                </div>
              </div>
            </div>

            <div className="relative" data-id="element-147">
              <div className="absolute inset-0 bg-brand-leather translate-x-4 translate-y-4 rounded-sm" data-id="element-148"></div>
              <img src="https://cdn.magicpatterns.com/uploads/r78gFzpmsNjcdavFnWNwrr/property-sign.jpg" alt="Large in-store selection at Kjergaard Sports" className="relative z-10 w-full h-auto rounded-sm shadow-lg object-cover" data-id="element-149" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-brand-hunter text-brand-offwhite bg-texture" data-id="element-150">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-151">
          <Users className="w-12 h-12 text-brand-leather mx-auto mb-6" data-id="element-152" />
          <h2 className="text-3xl md:text-4xl font-serif mb-6" data-id="element-153">
            Built Around In-Person Service
          </h2>
          <p className="text-xl text-brand-offwhite/80 leading-relaxed mb-10" data-id="element-154">
            We don't sell products directly through this website because we
            believe in the value of in-person service. When you visit Kjergaard
            Sports, you get practical, knowledgeable guidance from staff who
            actually use the equipment. Whether you're a first-time buyer or an
            experienced collector, we're here to help you find exactly what you
            need.
          </p>
          <Link to="/contact" className="inline-block bg-brand-leather hover:bg-brand-wood text-brand-offwhite px-8 py-4 rounded-sm font-medium transition-colors text-lg" data-id="element-155">
            Plan Your Visit to Lake Benton
          </Link>
        </div>
      </section>
    </div>;
}